import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "location",
  "use": "location-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"currentColor\" viewBox=\"0 0 48 48\" id=\"location\">\n  <path d=\"M24 6a12.03 12.03 0 0 0-12 12 11.7 11.7 0 0 0 .447 3.137 12 12 0 0 0 .733 1.967C13.449 23.668 24 42 24 42s10.51-18.332 10.779-18.896a12 12 0 0 0 .733-1.967A11.7 11.7 0 0 0 36 18 12.03 12.03 0 0 0 24 6m0 17a5.14 5.14 0 0 1-5-5 5.14 5.14 0 0 1 5-5 5.14 5.14 0 0 1 5 5 5.14 5.14 0 0 1-5 5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol